import React from "react";
import { Button, Modal } from "react-bootstrap";

const SuccessModal = (props) => {
  return (
    <>
      <Modal show={props.isOpen} onHide={props.onClosed} centered>
        <Modal.Body>
          {/* <span onClick={props.onClosed} className="position-absolute end-0 top-0 pe-2 pt-1 cursor-pointer signupCroseBtn">
            <i className="fa-regular fa-2x fa-xmark"></i>
          </span> */}
          <h6 className="text-success">{props?.description}</h6>
          <h6>{props.title}</h6>
          {props.content && <h6>{props.content}</h6>}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onClosed} variant="success">
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SuccessModal;
